// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import xinstEntity from './entities/xinst.json';
import xinstMenu from '../pages/xinst/menu.json';
import xinstFullForm from '../pages/xinst/forms/full.json';
import xinstContextForm from '../pages/xinst/forms/context.json';
import xinstMiniForm from '../pages/xinst/forms/mini.json';
import xinstLookupForm from '../pages/xinst/forms/lookup.json';
import xinstTableView from '../pages/xinst/views/table.json';
import xinstStagesView from '../pages/xinst/views/stages.json';
import xinstCardsView from '../pages/xinst/views/cards.json';
import xinstInlineView from '../pages/xinst/views/inline.json';
import xinstBacklogView from '../pages/xinst/views/backlog.json';
import xinstSplitView from '../pages/xinst/views/split.json';
import xinstCalendarView from '../pages/xinst/views/calendar.json';
import xinstDashboardView from '../pages/xinst/views/dashboard.json';

/** Тип запису «Установа» зі сторінками пакета: меню, форми та подання з pages/xinst/. */
export const xinstDefinition: IRecordTypeDefinition = {
  ...xinstEntity,
  views: assembleViewSet({
      table: xinstTableView,
      stages: xinstStagesView,
      cards: xinstCardsView,
      inline: xinstInlineView,
      backlog: xinstBacklogView,
      split: xinstSplitView,
      calendar: xinstCalendarView,
      dashboard: xinstDashboardView,
  }),
  form: xinstFullForm,
  forms: { full: xinstFullForm, context: xinstContextForm, mini: xinstMiniForm, lookup: xinstLookupForm },
  menu: xinstMenu,
} as IRecordTypeDefinition;
